import React from 'react';
import {GatsbyBrowser} from 'gatsby';

import {BrowserWrapper} from './src/providers/apollo/browser';
import {PrivacyProvider} from './src/providers/privacy';
import {RegionProvider} from './src/providers/region';
import {Scripts} from './src/providers/Scripts';
import {obs} from './src/utils/observer';
import {StripeBoundary} from './src/utils/stripe/boundary';
import {dataLayer} from './src/utils/window/dataLayer';
import {facebook} from './src/utils/window/facebook';
import {hsChat, hsTrack} from './src/utils/window/hubspot';

import 'bodyspec-shared-components/lib/index.css';
import './src/index.scss';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({element}) => {
	return (
		<BrowserWrapper>
			<PrivacyProvider>
				<RegionProvider>
					<StripeBoundary>
						{element}
					</StripeBoundary>
				</RegionProvider>
				<Scripts />
			</PrivacyProvider>
		</BrowserWrapper>
	);
};

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
	obs.init();

	if (window.location) {
		dataLayer.push({
			originalLocation:
				window.location.protocol + '//' +
				window.location.hostname +
				window.location.pathname +
				window.location.search,
		});
	}
};

// Runs before the next page renders, so replay can stop ahead of an
// excluded (report/account/payment) page reaching the DOM
export const onPreRouteUpdate: GatsbyBrowser['onPreRouteUpdate'] = ({location}) => {
	obs.beforeRoute(location.pathname);
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location, prevLocation}) => {
	hsChat.refresh();
	obs.page(location.pathname);

	if (prevLocation !== null) {
		hsTrack.setPath(location.pathname);
		hsTrack.trackPageView();
		facebook.viewContent();
	}
};
